import React from 'react';

import { ItemProvider } from '@common/react/components/Core/ItemProvider/ItemProvider';
import { ItemsProvider } from '@common/react/components/Core/ItemsProvider/ItemsProvider';
import { List } from '@common/typescript/objects/List';

import CustomRequestProvider from '@app/providers/CustomRequestProvider/CustomRequestProvider';
import PetMemorialHead from '@app/components/Pages/PetMemorial/PetMemorialHead';
import HelmetProvider from '@app/providers/HelmetProvider/HelmetProvider';
import PetMemorialBlock from '@app/components/UI/PetMemorialBlock/PetMemorialBlock';
import PetMemorialModalForm from '@app/components/UI/PetMemorialModal/PetMemorialModalForm';
import { BaseContentPage } from '@app/objects/ContentPage';
import { MemorialsRes } from '@app/objects/PetMemorial';
import '@app/scss/components/petMemorialHead.scss';

interface ContentPage extends BaseContentPage {
	items: List<MemorialsRes>
}

export const initCardsCount = 12;

const PetMemorial: React.FC = () => {
	const [modalFormVisible, setModalFormVisible] = React.useState<boolean>(false);

	const [sent, setSent] = React.useState<boolean>(false);

	React.useEffect(() => {
		window?.scrollTo(0, 0);
		document?.querySelector('#react-app')?.scrollTo(0, 0);
	}, []);

	return (
		<HelmetProvider<ContentPage>
			showLapOfLoveTitle={false}
		>
			{(page) => (
				<div id="pet-memorial">
					<CustomRequestProvider>
						<ItemsProvider
							type="memorials"
							loadRequest="memorials"
							skipInitLoad
							pagination={{
								pageSize: initCardsCount,
								total: page.items.count,
							}}
							items={page.items.list}
						>
							<>
								<PetMemorialHead onChangeSent={setSent} onChangeModalFormVisible={setModalFormVisible} />
								<PetMemorialBlock />
							</>
						</ItemsProvider>
					</CustomRequestProvider>

					<CustomRequestProvider requestMethod="POST">
						<ItemProvider
							id={-1}
							type="memorials"
							saveRequest="memorials"
						>
							<PetMemorialModalForm
								modalVisible={modalFormVisible}
								setModalVisible={setModalFormVisible}
								sent={sent}
								setSent={setSent}
							/>
						</ItemProvider>
					</CustomRequestProvider>
				</div>
			)}
		</HelmetProvider>
	);
};

export default PetMemorial;
